import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/merchant/scan',
    name: 'Merchant_Scan',
    component: () => import('@/views/merchant/Scan')
  },
  {
    path: '/user/signin:email?',
    name: 'User_SignIn',
    component: () => import('@/views/user/SignIn')
  },
  {
    path: '/user/signup',
    name: 'User_SignUp',
    component: () => import('@/views/user/SignUp')
  },
  {
    path: '/user/edit',
    name: 'Edit User',
    component: () => import('@/views/user/Edit')
  },
  {
    path: '/user/reset-password/:token',
    name: 'Reset_Password',
    component: () => import('@/views/user/ResetPassword')
  },
  {
    path: '/merchant/addplace/:id?',
    name: 'Merchant_AddPlace',
    component: () => import('@/views/merchant/AddPlace')
  },
  {
    path: '/points/history/:merchant?',
    name: 'Points History',
    component: () => import('@/views/points/UserPointsHistory')
  },
  {
    path: '/merchant/plan',
    name: 'Plans',
    component: () => import('@/views/merchant/Plans')
  },
  {
    path: '/thanks-page',
    name: 'Thank You Page',
    component: () => import('@/views/merchant/ThanksPage')
  },
  {
    path: '/merchant/billing-history',
    name: 'Billing History',
    component: () => import('@/views/merchant/BillingHistory')
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: () => import('@/views/merchant/Merchant')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/texts/About')
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('@/views/texts/PrivacyPolicy')
  },
  {
    path: '/terms-of-use',
    name: 'Terms of Use',
    component: () => import('@/views/texts/TermsOfUse')
  },
  {
    path: '/full-history/:merchant?',
    name: 'Full History',
    component: () => import('@/views/points/FullPerksList')
  },
  {
    path: '/how-it-works',
    name: 'How it works',
    component: () => import('@/views/texts/HowWorks')
  },
    
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to, from) => {
  document.getElementById('app').scrollIntoView() // scroll to top after each route change
})


export default router
